import {
  Typography,
  Grid,
  Link,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  Button,
  ConfirmationButton,
  TextField,
} from '@roc/ui';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { useRoutes, useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';
import { getRequestCreditAuthEmailBodyContent, getRequestCreditAuthSubject } from 'libs/client-portal-shared/src/app/modules/creditBackground/requestCreditAuthorization';
import { renderToString } from 'react-dom/server';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    instruction: {
      fontWeight: 600,
    },
    underline: {
      fontWeight: 600,
      textDecorationLine: 'underline',
    },
  })
);

export const PersonalAndCreditInformationLink = observer(({ store }) => {

  const classes = useStyles();
  const { currentBorrower } = store;
  const { requestCreditAuthStore } = useStore();
  const { messageConfig } = requestCreditAuthStore;
  const { creditBackgroundRoutesConfig } = useRoutes();

  useEffect(() => {
    getMessageConfig();
  }, [store.personalGuarantor]);

  const getMessageConfig = async () => {
    await requestCreditAuthStore.getMessageConfig(store.personalGuarantor, currentBorrower?.borrowerId, store.borrowerDetailsVerification?.savedForm?.requestToken, store.borrowerDetailsVerification?.lenderId);
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(messageConfig?.link);
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'Link was copied to clipboard!',
    });
  };

  const subject = getRequestCreditAuthSubject(store.personalGuarantor);
  const bodyContent = getRequestCreditAuthEmailBodyContent(currentBorrower?.fullName, messageConfig?.link, store.personalGuarantor, messageConfig?.tpoName);

  const handleConfirm = () => {
    const emailBodyContent = renderToString(bodyContent);
    requestCreditAuthStore.sendRequestCreditAuthorizationEmail(currentBorrower?.emailAddress, subject, emailBodyContent);
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'Email was sent to borrower!',
    });
  }

  return (
    <>
      {messageConfig?.link &&
        <Grid item xs={12} container justifyContent="center" spacing={2}>
          <Grid
            alignItems="center"
            container
            item
            justifyContent="center"
            xs={12}
          >
            <Grid item container xs={11} spacing={2}>
              <Grid item>
                <Typography className={classes.instruction}>
                  You can click on "copy link" and send to the borrower.
                </Typography>
              </Grid>
              <Grid item container alignItems="center" spacing={2}>
                <Grid item xs={12} sm>
                  <TextField
                    testId="idVerificationLink"
                    variant="outlined"
                    value={messageConfig?.link}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleCopy}
                    testId="copyIdVerificationUrlButton"
                    fullWidth
                  >
                    COPY LINK
                  </Button>
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid item>
                  <Typography className={classes.instruction}>
                    {`You can also click "email link to borrower" and we will send the link automatically to the borrower `}<span className={classes.underline}>{store.currentBorrower?.emailAddress}</span>{`. If you want to see a preview of the email first, please navigate to`}<Link href={creditBackgroundRoutesConfig.requestAuthorization.url} target="_blank" rel="noopener noreferrer"><span> Request Authorization.</span></Link>
                  </Typography>
                </Grid>
                <Grid item container justifyContent="center">
                  <ConfirmationButton
                    variant="contained"
                    onClick={handleConfirm}
                    color="primary"
                    testId="sendIdVerificationButton"
                    confirmDialogProps={{
                      title: 'Confirmation',
                      body: 'Email will be sent out. Please confirm',
                    }}
                  >
                    Email Link to Borrower
                  </ConfirmationButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </>
  );
});